import { Head } from '@inertiajs/react'
import { FaceDetector, FilesetResolver } from '@mediapipe/tasks-vision'
import { Box, Container, Stack } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import Consent from '~/components/consent'
import End from '~/components/end'
import InitiateKyc from '~/components/initiateKyc'
import Instruction from '~/components/instruction'
import LanguagePreference from '~/components/LanguagePreference'
import KycSelfieCapture from '~/components/KycSelfieCapture'
import SurroundingCapture from '~/components/SurroundingCapture'
import Video from '~/components/video'
import VoiceQuestion from '~/components/VoiceQuestion'
import VideoDoc from '~/components/videoDoc'
import Welcome from '~/components/welcome'

export default function Kyc(props: {
  version: number
  token: string
  id: number
  is_demo: boolean
  event_name?: string
}) {
  const webSocketRef = useRef<WebSocket | null>(null)
  const [socketData, setSocketData] = useState<any>(null)
  const [step, setStep] = useState(0)
  const [faceDetection, setFaceDetection] = useState<FaceDetector | null>(null)

  const initializefaceDetector = async () => {
    const vision = await FilesetResolver.forVisionTasks('wasm/wasm')
    const facedetector = await FaceDetector.createFromOptions(vision, {
      baseOptions: { modelAssetPath: 'models/face_detection.tflite', delegate: 'GPU' },
      runningMode: 'VIDEO',
      minDetectionConfidence: 0.5,
    })

    setFaceDetection(facedetector)
  }

  useEffect(() => {
    const wsUrl = `${import.meta.env.VITE_ML_HOST}/ws`
    if (wsUrl && step === 5) {
      webSocketRef.current = new WebSocket(wsUrl)
      // webSocketRef.current.binaryType = 'arraybuffer'
      webSocketRef.current.onmessage = (event) => {
        const data = JSON.parse(event.data)
        console.log('data from socket/ kyc.tsx', data)
        setSocketData(data)
      }
    }
  }, [step])

  useEffect(() => {
    initializefaceDetector()
    console.log('model-loaded')
  }, [])

  const onContinue = () => {
    setStep(step + 1)
  }

  const timeOut = () => {
    setStep(step - 1)
  }

  if (!props.id) return window.location.reload()
  return (
    <>
      <Head title="Homepage" />

      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          height: '100vh',
          background: 'url("./images/background.svg") no-repeat center',
        }}
      />
      <Container maxWidth="sm" sx={{ position: 'relative', pb: 12 }}>
        <Stack pb={12} pt={4} minHeight={1} textAlign="center">
          {
            [
              <LanguagePreference {...{ onContinue }} />,
              <Welcome {...{ onContinue }} />,
              <Consent {...{ onContinue }} />,
              <Instruction {...{ onContinue, id: props.id }} />,
              <SurroundingCapture {...{ onContinue, id: props.id }} />,
              <InitiateKyc {...{ onContinue }} />,
              <Video {...{ faceDetection, onContinue, socketData, webSocketRef, timeOut, ...props }} />,
              <KycSelfieCapture {...{ onContinue, id: props.id }} />,
              <InitiateKyc {...{ onContinue, step: 1 }} />,
              <VideoDoc {...{ onContinue, id: props.id }} />,
              <VoiceQuestion
                key="q-occupation"
                questionKey="occupation"
                titleEn="What is your current occupation and how long have you been working there?"
                titleHi="आपका वर्तमान व्यवसाय क्या है और आप वहाँ कब से काम कर रहे हैं?"
                onContinue={onContinue}
                id={props.id}
              />,
              <VoiceQuestion
                key="q-active_loans"
                questionKey="active_loans"
                titleEn="Do you have any other active loans?"
                titleHi="क्या आपके पास कोई अन्य सक्रिय ऋण है?"
                onContinue={onContinue}
                id={props.id}
              />,
              <End {...{ webSocketRef, onContinue, id: props.id, event_name: props.event_name }} />,
            ][step]
          }
        </Stack>
      </Container>
    </>
  )
}
